module.exports = __webpack_public_path__ + "media/images/konintodoke/konintodoke-top-image-3e5737fbc4c1d592acbdb849e5b8a546.jpg";